import { useState } from 'react';
import {
    ModalVariant,
    OperatorRoutedModal,
} from '../ui/modal/OperatorRoutedModal.tsx';
import { ParkingPortalLayoutWithHeader } from '../mobile/layout/ParkingPortalLayoutWithHeader.tsx';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import { Box, TextField } from '@mui/material';
import { SubmitButton } from '../ui/buttons/SubmitButton.tsx';
import { Outlet, useNavigate } from 'react-router-dom';

export function CloudConnectorRecodeLicensePlateSerach() {
    const [licensePlateNr, setLicensePlateNr] = useState('');
    const navigate = useNavigate();
    return (
        <OperatorRoutedModal
            variant={ModalVariant.MOBILE}
            backUrl={'..'}
            render={() => (
                <>
                    <ParkingPortalLayoutWithHeader
                        title={
                            <Localized
                                de="Rabatt erfassen"
                                fr="Saisir rabais"
                                it="Registra ribasso"
                                en="Record discount"
                            />
                        }
                        backTo={'..'}
                        padded
                    >
                        <Box sx={{ flexGrow: 1 }}>
                            <Box
                                sx={{
                                    fontSize: 24,
                                    fontWeight: 700,
                                    textAlign: 'center',
                                    paddingBottom: '16px',
                                    color: theme => theme.palette.primary.main,
                                }}
                            >
                                <Localized
                                    de="Kennzeichen"
                                    fr="Immatriculation"
                                    it="Numero di targa"
                                    en="License plate"
                                />
                            </Box>
                            <Box>
                                <TextField
                                    variant="filled"
                                    value={licensePlateNr}
                                    onChange={e => {
                                        setLicensePlateNr(
                                            e.target.value.toUpperCase(),
                                        );
                                    }}
                                    sx={theme => ({
                                        width: '100%',
                                        '& .MuiInputBase-input': {
                                            borderRadius: '3px',
                                            backgroundColor:
                                                theme.palette.blue.medium,
                                            color: theme.palette.primary.main,
                                            fontSize: '24px',
                                            padding: '8px',
                                        },
                                    })}
                                />
                            </Box>
                        </Box>
                        <SubmitButton
                            disabled={licensePlateNr.length === 0}
                            loading={false}
                            onClick={() => {
                                navigate(`licensePlateNr/${licensePlateNr}`);
                            }}
                            sx={{ paddingY: '16px' }}
                            label={
                                <Localized
                                    de="Suchen"
                                    fr="Rechercher"
                                    it="Cercare"
                                    en="Search"
                                />
                            }
                        />
                    </ParkingPortalLayoutWithHeader>
                    <Outlet />
                </>
            )}
        />
    );
}
